import React from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

const CashExpensesPrintOut = React.forwardRef(
  ({ data, onsendinvoicedata }, ref) => {
    // const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store

    let ledgerFilters = useSelector(
      (state) => state.customer.ledgers.ledgersFilter
    );

    const printbody = {
      display: "flex",
      flexDirection: "column",
      width: "297mm",
      minHeight: "420mm",
      padding: "4px",
      margin: "0 auto",
      backgroundColor: "#fff",
      boxSizing: "border-box",
    };
    //formate dagte dd-Month-YY

    // function formatDate(dateString) {
    //   const months = [
    //     "Jan",
    //     "Feb",
    //     "Mar",
    //     "Apr",
    //     "May",
    //     "Jun",
    //     "Jul",
    //     "Aug",
    //     "Sep",
    //     "Oct",
    //     "Nov",
    //     "Dec",
    //   ];

    //   const date = new Date(dateString);

    //   const day = String(date.getDate()).padStart(2, "0");
    //   const month = months[date.getMonth()];
    //   const year = date.getFullYear().toString().slice(-2);

    //   return `${day}-${month}-${year}`;
    // }

    const convertNumberToWords = (num) => {
      if (num === "" || isNaN(num)) return "";
      num = parseFloat(num).toFixed(2); // Ensure two decimal places
      let [rupees, paise] = num.split("."); // Split rupees and paise
      rupees = parseInt(rupees);
      paise = parseInt(paise);

      const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];

      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

      const convertBelowThousand = (n) => {
        if (n < 20) return ones[n];
        if (n < 100)
          return (
            tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
          );
        return (
          ones[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 !== 0 ? " " + convertBelowThousand(n % 100) : "")
        );
      };

      let words = "";
      let scaleIndex = 0;

      while (rupees > 0) {
        let part = rupees % 1000;
        if (part !== 0) {
          words =
            convertBelowThousand(part) +
            " " +
            scales[scaleIndex] +
            (words ? " " + words : "");
        }
        rupees = Math.floor(rupees / 1000);
        scaleIndex++;
      }

      words = words.trim() ? words.trim() + " Rupees" : "";

      if (paise > 0) {
        let paiseWords = convertBelowThousand(paise) + " Paise";
        words += " and " + paiseWords;
      }

      return words || "Zero Rupees";
    };
    return (
      <div ref={ref} style={printbody} className="m-4">
        <p className="text-center fs-4 fw-bold m-0 p-0">
          {ledgerFilters[0]?.description}
        </p>
        {/* <p className="my-0 py-0 text-center">
          No. 224, 17th C Main, Sector, Hsr Layout
        </p>
        <p className="my-0 py-0 text-center mb-2">Bangalore - 560102</p> */}
        <p className="text-center m-0 p-0 fs-4 fw-bold">Payment Voucher</p>

        <Row>
          <Col xs={12} md={12} lg={12}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                {/* Row: No & Date */}
                <tr>
                  <td>
                    {" "}
                    <span className="fw-bold">No : </span> {data?.voucherNumber}{" "}
                  </td>
                  <td style={{ padding: "4px" }} className="text-start">
                    {/* {data?.voucherNumber} */}
                  </td>
                  <td></td>
                  <td
                    style={{
                      padding: "4px",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  ></td>
                  <td style={{ padding: "4px", textAlign: "right" }}>
                    <span className="fw-bold">Dated : </span>{" "}
                    {data?.postingDate}
                  </td>
                </tr>

                {/* Header Row */}
                <tr>
                  <th
                    style={{
                      borderTop: "1px solid black",
                      borderBottom: "1px solid black",
                      padding: "4px",
                      textAlign: "left",
                    }}
                  >
                    Particulars
                  </th>
                  <th
                    style={{
                      borderTop: "1px solid black",
                      borderBottom: "1px solid black",
                      padding: "4px",
                      textAlign: "right",
                    }}
                    colSpan={4}
                  >
                    Amount
                  </th>
                </tr>

                {/* Account Row */}
                <tr>
                  <td>
                    Account :{" "}
                    <span className="fw-bold">{data?.customerCodeDesc}</span>
                  </td>

                  <td
                    colSpan={2}
                    style={{
                      padding: "4px",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                    }}
                    className="text-start"
                  >
                    {/*  {data?.customerCodeDesc} */}
                  </td>

                  {/* <td style={{ padding: "4px", textAlign: "right" }}>
                      {data?.items[0]?.debitAmount && data?.items[0]?.debitAmount}
                      {data?.items[0]?.creditAmount && data?.items[0]?.creditAmount}
                  </td> */}
                  <td style={{ padding: "4px", textAlign: "right" }}></td>
                  <td
                    style={{ padding: "4px", textAlign: "right" }}
                    className="fw-bold"
                  >
                    {data?.items?.length > 0 && (
                      <>
                        {data.items[0]?.debitAmount}
                        {data.items[0]?.creditAmount}
                      </>
                    )}
                  </td>
                </tr>

                {/* Big Blank Space Row (like image) */}
                <tr>
                  <td colSpan={5} style={{ height: "120px" }}></td>
                </tr>

                {/* Through Section */}
                <tr>
                  <td
                    colSpan={5}
                    style={{ padding: "4px", fontWeight: "bold" }}
                  >
                    Through :
                  </td>
                </tr>
                <tr>
                  <td colSpan={5} style={{ padding: "4px" }}>
                   {data?.companyBank}
                  </td>
                </tr>

                {/* On Account of */}
                <tr>
                  <td
                    colSpan={5}
                    style={{ padding: "4px", fontWeight: "bold" }}
                  >
                    On Account of :
                  </td>
                </tr>
                <tr>
                  <td colSpan={5} style={{ padding: "4px" }}>
                    HPCL HNS || HPCL HNS PAYMENT
                    <br />
                    UTR No.: IN42533752885700
                  </td>
                </tr>

                {/* Amount in words */}
                <tr>
                  <td
                    colSpan={5}
                    style={{ padding: "4px", fontWeight: "bold" }}
                  >
                    Amount (in words) :
                  </td>
                </tr>
                <tr>
                  <td colSpan={5} style={{ padding: "4px" }}>
                    {data?.items?.length > 0 && (
                      <>
                        {data?.items[0]?.debitAmount !== 0 &&
                          convertNumberToWords(data?.items[0]?.debitAmount)}
                        {data?.items[0]?.creditAmount !== 0 &&
                          convertNumberToWords(data?.items[0]?.creditAmount)}
                      </>
                    )} only
                  </td>
                </tr>

                {/* Bottom Right Total */}
                <tr>
                  <td colSpan={4}></td>
                  <td
                    style={{
                      borderTop: "1px solid black",
                      padding: "6px",
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                  >
                    {data?.items?.length > 0 && (
                      <>
                        {data.items[0]?.debitAmount}
                        {data.items[0]?.creditAmount}
                      </>
                    )}
                  </td>
                </tr>
                <tr>
                 <td className="tex-start mt-5 pt-5 fw-bold"></td>                 
                </tr>
                <tr>
                 <td className="tex-start mt-5 pt-5 fw-bold"></td>                 
                </tr>
                <tr >
                  <td className="tex-start mt-5 pt-5 fw-bold"> Receiver's Signature</td>
                  <td colSpan={3}></td>
                  <td className="text-end mt-5 pt-5 fw-bold"> Authorised Signatory</td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>

        <div className="text-center ">
          {/* <p>SUBJECT TO BENGALURU JURISDICTION</p>
        <p>This is a Computer Generated Invoice</p> */}
        </div>
      </div>
    );
  }
);

export default CashExpensesPrintOut;
